<template>
  <span class="chip" :class="tone">
    <span v-if="dot" class="dot" />
    <slot>{{ label }}</slot>
  </span>
</template>

<script setup lang="ts">
// Small status pill used across the drawer: verification/spam-label status,
// pool health, and the "Admin only" affordance marker.
withDefaults(
  defineProps<{
    tone?: 'amber' | 'success' | 'neutral'
    label?: string
    dot?: boolean
  }>(),
  { tone: 'neutral', dot: false },
)
</script>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: var(--fw-semibold);
  white-space: nowrap;
}
.dot { width: 7px; height: 7px; border-radius: var(--radius-full); flex-shrink: 0; background: currentColor; }
.chip.neutral { background: var(--color-bg-subtle); color: var(--color-text-tertiary); }
.chip.amber { background: var(--hue-amber-soft); border: 1px solid var(--hue-amber-edge); color: var(--hue-amber); }
.chip.success { background: var(--color-success-soft); border: 1px solid var(--color-success-edge); color: var(--color-success); }
</style>
